/* eslint-disable max-len */
import React, { useState } from 'react';
import { useForm, Controller, SubmitHandler } from 'react-hook-form';
import { classNames } from 'shared/lib/classNames/classNames';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, ButtonTheme } from 'shared/ui/Button/Button';
import { BackgroundHandler } from 'shared/ui/BackgroundHandler/BackgroundHandler';
import Api from 'app/api/Api';
import cls from './RecoveryPage.module.scss';
import {useApi} from "app/api/APIProvider";
import {APIError} from "app/api/NewAPI";

type FormData = {
  password: string;
  password_repeat: string;
};

interface RecoveryPageProps {
    className?: string,
}

export const RecoveryPage: React.FC<RecoveryPageProps> = ({ className }) => {
    const token = (useParams<{token: string}>())?.token ?? '-';
    const navigate = useNavigate();
    const api = useApi()
    const {
        control,
        handleSubmit,
        formState: { errors },
    } = useForm<FormData>();

    const onSubmit: SubmitHandler<FormData> = async (data) => {
        try{
            debugger
            await api.PasswordReset({...data, token})
            navigate('/');
        } catch (e: unknown){
            const error = e as APIError
        }
        // console.log(data);
        // // Здесь вы можете выполнить отправку данных на сервер или другую логику обработки данных.
        // const res = await Api({
        //     endpoint: 'password-reset',
        //     method: 'POST',
        //     data: { ...data, token },
        // });
        //
        // if (res.code === 'OK') {
        //     sessionStorage.removeItem('accessToken');
        //     navigate('/');
        // } else {
        //     console.log(res, 'err');
        // }
    };

    return (
        <div className={cls.page}>
            <BackgroundHandler />
            <div className={cls.formWrapper}>
                <h3 className={cls.title}>Восстановление пароля</h3>
                <form className={cls.form} onSubmit={handleSubmit(onSubmit)}>
                    <div className={cls.flexWrapper}>
                        <div className={cls.cell}>
                            <Controller
                                name="password"
                                control={control}
                                rules={{
                                    required: 'Заполните поле',
                                    validate: (value: any) => {
                                        if (!(/^[a-zA-Z0-9!@#$%^&*()_+{}\[\]:;<>,.?/~`|\\-]+$/.test(value) && value.length > 1)) {
                                            return 'Вводите только латинские буквы';
                                        }
                                        if (!(value.length >= 8)) {
                                            return 'Пароль должен быть длинее 8 символов';
                                        }
                                        if (!(/.*[A-Z].*/.test(value))) {
                                            return 'Пароль должен содержать одну латинскую букву в верхнем регистре';
                                        }
                                        if (!(/.*[a-z].*/.test(value) && value.length > 1)) {
                                            return 'Пароль должен содержать одну латинскую букву в нижнем регистре';
                                        }
                                        return true;
                                    },
                                }}
                                render={({ field }) => (
                                    <div className={cls.flexWrapper}>
                                        <input className={cls.field} {...field} placeholder="Введите новый пароль" />
                                    </div>
                                )}
                            />
                            {errors.password && <p>{errors.password.message}</p>}
                        </div>
                        <div className={cls.cell}>
                            <Controller
                                name="password_repeat"
                                control={control}
                                rules={{
                                    required: 'Заполните поле',
                                    validate: (value: any) => {
                                        if (!(/^[a-zA-Z0-9!@#$%^&*()_+{}\[\]:;<>,.?/~`|\\-]+$/.test(value) && value.length > 1)) {
                                            return 'Вводите только латинские буквы';
                                        }
                                        if (!(value.length >= 8)) {
                                            return 'Пароль должен быть длинее 8 символов';
                                        }
                                        if (!(/.*[A-Z].*/.test(value))) {
                                            return 'Пароль должен содержать одну латинскую букву в верхнем регистре';
                                        }
                                        if (!(/.*[a-z].*/.test(value) && value.length > 1)) {
                                            return 'Пароль должен содержать одну латинскую букву в нижнем регистре';
                                        }
                                        return true;
                                    },
                                }}
                                render={({ field }) => (
                                    <div className={cls.flexWrapper}>
                                        <input className={cls.field} {...field} placeholder="Повторите пароль" />
                                    </div>
                                )}
                            />
                            {errors.password_repeat && <p>{errors.password_repeat.message}</p>}
                        </div>
                    </div>
                    <div className={cls.buttonWrapper}>
                        <Button type="submit" theme={ButtonTheme.AUTH}>
                            Сбросить
                        </Button>
                    </div>
                    <p className={cls.label}>
                        ООО «СберСтрахование жизни»
                    </p>
                </form>
            </div>
        </div>
    );
};
